// export const expect = (funcResult) => {
//   let result = funcResult;
//   function toBe(expected) {
//     return {
//       result: JSON.stringify(result) === JSON.stringify(expected),
//       expected,
//       received: result,
//     };
//   }

//   return { toBe };
// };

export const expectCode = `
const expect = (funcResult) => {
    let result = funcResult;
    function toBe(expected) {
        results.push({
            result: JSON.stringify(result) === JSON.stringify(expected),
            expected,
            received: result,
        });
    }
    return { toBe };
  };
`;

export const defaultTestCase = `expect(test()).toBe();`;

export const consoleLog = `
const results = [];
const _consoleLog = console.log;
const logs = [];

console.log = (...args) => {
   // _consoleLog('CDH logs:', ...args);
   logs.push(args.map(a => {
    if (!a) return String(a);
    if (typeof a === 'object') return JSON.stringify(a);
    return a;
   }).join(' '));
}

results.logs = logs;
`;
